import api from './axios';

export interface SubscriptionInfo {
  empresa: {
    id: string;
    nome: string;
    email: string;
  };
  assinatura: {
    id: string;
    status: string;
    intervalo: string;
    dataInicio: string;
    dataFimTrial: string | null;
    proximaCobranca: string | null;
    valorAtual: number;
    plano: {
      id: string;
      nome: string;
      slug: string;
      features: string[];
    };
    pagamentos: Array<{
      id: string;
      valor: number;
      status: string;
      metodo: string;
      dataPagamento: string | null;
      dataVencimento: string;
    }>;
  } | null;
}

export const subscriptionApiService = {
  async getCurrentSubscription(): Promise<SubscriptionInfo> {
    const response = await api.get<SubscriptionInfo>('/subscription/current');
    return response.data;
  },

  async getPaymentHistory(page = 1, limit = 10) {
    const response = await api.get('/subscription/payments', {
      params: { page, limit },
    });
    return response.data;
  },

  async updatePlan(planoSlug: string, intervalo: string) {
    const response = await api.put('/subscription/plan', { planoSlug, intervalo });
    return response.data;
  },

  async cancelSubscription(motivo: string) {
    const response = await api.post('/subscription/cancel', { motivo });
    return response.data;
  },

  async reactivateSubscription() {
    const response = await api.post('/subscription/reactivate');
    return response.data;
  },

  async updatePaymentMethod(cardToken: string) {
    const response = await api.put('/subscription/payment-method', { cardToken });
    return response.data;
  },
};

export default subscriptionApiService;
